<!-- <div *ngIf="click ;else noClick">
<div class="row mt-5">
  <h1 class="text-success fst-italic  mt-1 ms-2">Trending</h1>
<div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending ;let i =index">
    <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{movie.title}}</h5>
      <p class="card-text overflow-hidden"style="height:50px">{{movie.description}}</p>
      <a  class="btn btn-primary" (click)="viewTrending(i)">View More</a>
    </div>
  </div>
</div>

<div class="row">
  <h1 class="text-success fst-italic  mt-1 ms-2">Tamil Movies</h1>
<div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of tamilMovies ;let i =index">
    <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{movie.title}}</h5>
      <p class="card-text">{{movie.description}}</p>
      <a  class="btn btn-primary" (click)="viewTamilMovies(i)">View More</a>
    </div>
  </div>
</div>
<div class="row">
  <h1 class="text-success fst-italic  mt-1 ms-2">Hollywood Movies</h1>
<div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of hollywood ; let i = index">
    <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{movie.title}}</h5>
      <p class="card-text">{{movie.description}}</p>
      <a  class="btn btn-primary" (click)="viewhollywoodMovies(i)">View More</a>
    </div>
  </div>
</div>

<div class="row">
  <h1 class="text-success fst-italic  mt-1 ms-2">Bollywood Movies</h1>
<div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of bollywood ; let i = index">
    <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{movie.title}}</h5>
      <p class="card-text">{{movie.description}}</p>
      <a  class="btn btn-primary" (click)="viewbollywoodMovies(i)">View More</a>
    </div>
  </div>
</div>
</div>
<ng-template #noClick>
  <div *ngIf="trendingClick" class="mt-5 card">
    <img src="{{Trending[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{Trending[findData].title || tamilMovies[findData].title}}</h5>
      <p class="card-text">{{Trending[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
  <div *ngIf="tamilClick" class="mt-5 card">
    <img src="{{tamilMovies[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{tamilMovies[findData].title}}</h5>
      <p class="card-text">{{tamilMovies[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>

  <div *ngIf="hollywoodClick" class="mt-5 card">
    <img src="{{hollywood[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{hollywood[findData].title}}</h5>
      <p class="card-text">{{hollywood[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
  <div *ngIf="bollywoodClick" class="mt-5 card">
    <img src="{{bollywood[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{bollywood[findData].title}}</h5>
      <p class="card-text">{{bollywood[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
</ng-template>
 -->
 <div *ngIf="click ;else noClick">
<div id="carouselExampleControls" class="carousel slide">
  <div class="carousel-inner">
    <h1 class="text-success fst-italic  mt-1 ms-2">Trending</h1>
    <div class="carousel-item active ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending1 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending2 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span class="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span class="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<div id="carouselExampleControls" class="carousel slide">
  <div class="carousel-inner">
    <h1 class="text-success fst-italic  mt-1 ms-2">Trending</h1>
    <div class="carousel-item active ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending1 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending2 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span class="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span class="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<div id="carouselExampleControls" class="carousel slide">
  <div class="carousel-inner">
    <h1 class="text-success fst-italic  mt-1 ms-2">Trending</h1>
    <div class="carousel-item active ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending1 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending2 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span class="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span class="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<div id="carouselExampleControls" class="carousel slide">
  <div class="carousel-inner">
    <h1 class="text-success fst-italic  mt-1 ms-2">Trending</h1>
    <div class="carousel-item active ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending1 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ms-5">
      <div class="row">
        <div class="card col-12 m-2" style="width: 18rem;" *ngFor="let movie of Trending2 ;let i =index">
          <img src="{{movie.imgSrc}}" style="height: 300px;" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{movie.title}}</h5>
            <p class="card-text overflow-hidden" style="height:50px">{{movie.description}}</p>
            <a class="btn btn-primary" (click)="viewTrending(i)">View More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span class="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span class="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<div class="bg-dark text-danger text-center fst-italic" style="height: 40px;">
   <h4>COPY RIGHT @2023 JLIVX</h4>
</div>
</div>
<ng-template #noClick>
  <div *ngIf="trendingClick" class="mt-5 card">
    <img src="{{Trending[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{Trending[findData].title || tamilMovies[findData].title}}</h5>
      <p class="card-text">{{Trending[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
  <div *ngIf="tamilClick" class="mt-5 card">
    <img src="{{tamilMovies[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{tamilMovies[findData].title}}</h5>
      <p class="card-text">{{tamilMovies[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>

  <div *ngIf="hollywoodClick" class="mt-5 card">
    <img src="{{hollywood[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{hollywood[findData].title}}</h5>
      <p class="card-text">{{hollywood[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
  <div *ngIf="bollywoodClick" class="mt-5 card">
    <img src="{{bollywood[findData].imgSrc}}" class="card-img-top" height="500px" alt="...">
    <div class="card-body">
      <h5 class="card-title">{{bollywood[findData].title}}</h5>
      <p class="card-text">{{bollywood[findData].description}}</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
</ng-template>